<template>
  <v-container fluid class="gl-post-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>

          <v-tab
            :href="`#tab-ledger`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-file-document</v-icon>
            Post
          </v-tab>
          <v-tab class="mr-5" :href="`#tab-items`" >
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Items
          </v-tab>
          <v-tab-item
            :value="'tab-ledger'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Edit Post</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangePost($event, 'postname')"
                        v-bind:value="initvalue.postname"
                        placeholder="Ledger Name"
                        persistent-hint
                        single-line hint="Enter the ledger name">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items="['New', 'Sent', 'Completed']"
                        v-model="initvalue.poststatus"
                        v-on:change="onChangePost($event, 'poststatus')"
                        outlined
                        dense
                        placeholder="Status"
                        persistent-hint
                        single-line
                        hint="Please choose the status"
                      >
                      </v-select>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                          to="/gl-post/list"
                          replace
                          outlined
                          color="primary"
                      >
                        Cancel
                      </v-btn>
                      <v-spacer></v-spacer>
                        <v-btn
                          :loading="isReceiving"
                          class="button-shadow"
                          color="primary"
                          @click="editGLPost()">
                          Save
                        </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-items'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row>
                  <v-col md="6">
                    <p class="text-h5">Items</p>
                  </v-col>
                  <v-col cols="6" sm="6" md="6" lg="6" class="d-flex flex-end justify-md-end overflow-auto" align="right">
                    <v-btn
                      v-show="isEditable"
                      class="button-shadow mr-1"
                      color="success"
                      @click="isAddTransaction=true; new_transaction={}">
                      Add
                    </v-btn>
                    <v-btn
                      class="button-shadow mr-1"
                        to="/bill/list"
                        replace
                        color="primary"
                      >
                        Done
                    </v-btn>
                  </v-col>
                  </v-row>
                  <v-data-table
                    sort-by="transrank"
                    :headers="header_items"
                    :items="transactions"
                    :items-per-page="1000"
                    :footer-props="footer"
                    class="elevation-0"
                  >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteTransaction" width="500">
                            <v-card>
                              <v-card-title> Delete this Item? </v-card-title>
                              <v-card-text>
                                {{ delete_transaction.itemdesc }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteTransaction = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteTransaction(delete_transaction)"
                                  >Delete</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.itemimage="{ item }">
                          <v-img
                            v-bind:lazy-src="item.itemimage"
                            min-width="50"
                            max-width="100"
                            v-bind:src="item.itemimage"
                          ></v-img>
                        </template>
                        <template v-slot:item.accountid="{ item }">
                          {{ accounts.length>0 ? accounts.find(account=>account._id == item.accountid)['accountname'] : '' }}
                        </template>
                        <template v-slot:item.transamount="{ item }">
                          {{ item.transamount.toFixed(2) }}
                        </template>
                        <template v-slot:item.transdate="{ item }">
                          {{ item.transdate!=null ? new Date(item.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '' }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            v-if="isEditable"
                            icon
                            color="primary"
                            @click="editTransactionDialog(item)"
                          >
                            <v-icon>mdi-pencil-outline</v-icon>
                          </v-btn>

                        </template>
                      </v-data-table>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <div>
      <v-dialog
        v-model="isEditTransaction"
        persistent
        width="1000px"
        max-width="1000px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items=data_classes
                    v-model="accountclass"
                    outlined
                    dense
                    placeholder="Class"
                    persistent-hint
                    single-line hint="Please choose the class">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items=data_subclasses
                    v-model="accountsubclass"
                    outlined
                    dense
                    placeholder="Subclass"
                    persistent-hint
                    single-line hint="Please choose the subclass">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items="accounts.filter(account=>account.accountsubclass==accountsubclass && account.accountsubtype=='Account').map(x => {
                        return {text: x.accountname, value: x._id};
                    })"
                    v-model="edit_transaction.accountid"
                    v-on:change="onChangeTransaction($event, 'accountid')"
                    outlined
                    dense
                    placeholder="Account"
                    persistent-hint
                    single-line hint="Account">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-menu
                    ref="menu_transdate_edit"
                    v-model="menu_transdate_edit"
                    :close-on-content-click="false"
                    :return-value.sync="edit_transaction.transdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        dense
                        v-model="edit_transaction.transdate"
                        v-on:change="onChangeTransaction($event, 'transdate')"
                        label="Transaction Date"
                        v-bind="attrs"
                        v-bind:value="edit_transaction.transdate"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please choose the transaction date">
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="edit_transaction.transdate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_transdate_edit = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_transdate_edit.save(edit_transaction.transdate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="5">
                  <v-text-field
                    v-model="edit_transaction.transdesc"
                    v-on:change="onChangeTransaction($event, 'transdesc')"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Desc"
                    persistent-hint
                    single-line hint="Description">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.currencyRate"
                    v-on:change="onChangeTransaction($event, 'currencyRate')"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Rate"
                    persistent-hint
                    single-line hint="Rate">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.creditAmount"
                    v-on:change="onChangeTransaction($event, 'creditAmount')"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Credit"
                    persistent-hint
                    single-line hint="Credit">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.debitAmount"
                    v-on:change="onChangeTransaction($event, 'debitAmount')"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Debit"
                    persistent-hint
                    single-line hint="Debit">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.creditAmount2"
                    v-on:change="onChangeTransaction($event, 'creditAmount2')"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Credit 2"
                    persistent-hint
                    single-line hint="Credit 2">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.debitAmount2"
                    v-on:change="onChangeTransaction($event, 'debitAmount2')"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Debit 2"
                    persistent-hint
                    single-line hint="Debit 2">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditTransaction=false; edit_transaction={}; change_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="updateTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import router from '@/Routes';
import { formatStdDate } from '@/mixins/date';
import {mapActions, mapState} from "vuex";

export default {
  data () {
    return {
      header_items: [
        { text: 'Date', value: 'transdate', width: '8%' },  
        { text: 'Type', value: 'transtype', width: '8%'},
        { text: 'Description', value: 'transdesc',},
        { text: 'Account', value: 'accountid', width: '20%' },
        { text: 'Credit', value: 'creditAmount', width: '10%'},
        { text: 'Debit', value: 'debitAmount', width: '10%'},
        { text: "Actions", value: "actions", sortable: false, width: '5%' },
      ],
      footer: {'items-per-page-options': [1000, 5000, 10000]},
      change_post: {},
      initvalue: {},
      edit_transaction: {},
      new_transaction: {},
      delete_transaction: {},
      transactions: [],
      accountclass: null,
      accountsubclass: null,
      menu_transdate: false,
      menu_transdate_edit: false,
      isDeleteTransaction: false,
      isEditTransaction: false, 
    }
  },
  methods: {
    ...mapActions('Account', ['getAccountsRequest']),
    ...mapActions('GLPost', ['updateGLPostRequest','updateGLPostTransaction','getGLPostRequest']),
    clearTransaction() {
      this.edit_transaction = {};
      this.new_transaction = {};
      this.change_transaction = {};
    },
    async editGLPost() {
      this.change_post._id = this.initvalue._id;
      await this.updateGLPostRequest(this.change_post);
      router.push('/gl-post/list');
    },
    onChangePost(value, field){
      this.change_post[field] = value;
    },
    onChangeTransaction(value, field){
      this.change_transaction[field] = value;
    },
    editTransactionDialog(item) {
      this.change_transaction = {};
      let account = this.accounts.find(account=>account._id == item.accountid);
      this.accountclass = account.accountclass;
      this.accountsubclass = account.accountsubclass;
      this.edit_transaction = Object.assign({}, item);
      this.edit_transaction.transdate = formatStdDate(this.edit_transaction.transdate);
      this.isEditTransaction = true;
    },
    async updateTransaction() {
      this.isEditTransaction = false;
      this.change_transaction._id = this.edit_transaction._id;
      let response = await this.updateGLPostTransaction(this.change_transaction);
      let index = this.transactions.findIndex((x) => x._id == response._id);
      this.transactions.splice(index, 1, response);
      this.clearTransaction();
      //this.getGLPostRequest();
    },
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('GLPost', ['isReceiving']),
    data_classes(){
      let object = Object.groupBy(this.accounts.filter(x=>x.accountclass=='Asset' || x.accountclass=='Liability' || x.accountclass=='Expense' ), item => {
        return item.accountclass;
      });
      let result = Object.keys(object);
      return result;
    },
    data_subclasses(){
      let filter = this.accounts.filter(account=>account.accountclass==this.accountclass);
      let object = Object.groupBy(filter, item => {
        return item.accountsubclass;
      });
      let result = Object.keys(object);
      return result;
    },
    isNotEditable(){
      let result = ['New'].indexOf(this.initvalue.poststatus) == -1;
      return result;
    },
    isEditable(){
      let result = ['New'].indexOf(this.initvalue.poststatus) >= 0;
      console.log(result);
      return result;
    },
  },
  async created () {
    this.initvalue = this.$route.params;
    if(!this.initvalue._id) this.$router.push({ name: 'GLPostList' });
    if (this.accounts.length==0) await this.getAccountsRequest();
    this.transactions = Object.assign([], this.initvalue.transactions);
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
